import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {PermissionName} from '../constants';
import {currentUserHasAccess} from './currentUserHasAccess';
import {legacyPermissionsEnabled} from './legacyPermissionsEnabled';

export const currentUserHasSystemAccess = (): boolean => {
	if (legacyPermissionsEnabled())
		return currentUserMeetsUserLevel(UserLevel.DIRECTOR);
	return [
		PermissionName.MANAGE_VOCABULARIES,
		PermissionName.MANAGE_PORTALS,
	].some(currentUserHasAccess);
};
